import { __assign } from "tslib";
import { useRef, useEffect } from 'react';
import ddt from '@wix/da-ddt';
var logger = process.env.NODE_ENV === 'test' ? console : ddt.createLogger('react');
// this is a helper to help debug re-renders
function objectDiff(from, to) {
    var diff = {};
    Object.keys(__assign(__assign({}, from), to)).forEach(function (key) {
        if (from[key] !== to[key]) {
            diff[key] = {
                from: from[key],
                to: to[key],
            };
        }
    });
    return diff;
}
export function useDebugRerenders(name, props) {
    var previousProps = useRef();
    useEffect(function () {
        if (previousProps.current) {
            var diff = objectDiff(previousProps.current, props);
            if (Object.keys(diff).length) {
                logger.log("".concat(name, " re-render reason:"), diff);
            }
            else {
                logger.log("".concat(name, " re-rendered without prop changes"));
            }
        }
        previousProps.current = props;
    });
}
//# sourceMappingURL=useDebugRerenders.js.map